import { toast } from "sonner";
import baseApi from "store/api/baseApi";

const jobApplicationApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    // Get all job applications
    getAllJobApplications: builder.query({
      query: () => ({
        url: "qwikITJobApplication/",
        method: "GET",
      }),
      providesTags: ["jobApplications"],
      transformResponse: response => response.reverse(),
    }),

    // Get a single job application by ID
    getJobApplication: builder.query({
      query: id => ({
        url: `qwikITJobApplication/${id}/`,
        method: "GET",
      }),
      providesTags: ["jobApplications"],
      transformResponse: response => response,
    }),

    // Create a new job application
    createJobApplication: builder.mutation({
      query: data => ({
        url: "qwikITJobApplication/new/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["jobApplications"],
      transformResponse: response => {
        toast.success("Job application submitted successfully");
        return response;
      },
    }),

    // Update job application
    updateJobApplication: builder.mutation({
      query: ({ id, formData }) => ({
        url: `qwikITJobApplication/${id}/`,
        method: "PATCH",
        body: formData,
      }),
      invalidatesTags: ["jobApplications"],
      transformResponse: response => {
        toast.success("Job application updated successfully");
        console.log("response response", response);
        return response;
      },
    }),

    // Delete job application
    deleteJobApplication: builder.mutation({
      query: id => ({
        url: `qwikITJobApplication/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["jobApplications"],
      transformResponse: response => {
        toast.success("Job application deleted successfully");
        return response;
      },
    }),

    // Get all jobs for filtering
    getAllJobsForFilter: builder.query({
      query: () => ({
        url: "qwikITJob/",
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetAllJobApplicationsQuery,
  useGetJobApplicationQuery,
  useCreateJobApplicationMutation,
  useUpdateJobApplicationMutation,
  useDeleteJobApplicationMutation,
  useGetAllJobsForFilterQuery,
} = jobApplicationApi;